import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { profileService } from '../../services/profileService';
import { UserProfile } from '../../types';

interface CoachRouteProps {
  children: React.ReactNode;
}

const CoachRoute: React.FC<CoachRouteProps> = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [profileLoading, setProfileLoading] = useState(true);

  useEffect(() => {
    const loadProfile = async () => {
      if (user?.id) {
        const userProfile = await profileService.getProfile(user.id);
        setProfile(userProfile);
        setProfileLoading(false);
      } else {
        setProfileLoading(false);
      }
    };

    loadProfile();
  }, [user]);

  if (authLoading || profileLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user || !profile) {
    return <Navigate to="/login" replace />;
  }

  // Check if user is a coach
  if (profile.user_role !== 'coach') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default CoachRoute;
